<template>
    <div>
        <info-item
            :isEnabled="isEnabled"
            :label="resource('DmVisualizer_ChangeInfo_Address')"
            @set-enabled="$emit('set-enabled', $event)"
        >
            <info-text-input
                :label="resource('Address_Street')"
                :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_Street')"
                :isEnabled="isEnabled"
                :scale="[2,10]"
                :value="street"
                @input="$emit('update:street', $event)"
            />
            <div class="row">
                <div class="col-6">
                    <info-text-input
                        :label="resource('Address_Zipcode')"
                        :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_Zipcode')"
                        :isEnabled="isEnabled"
                        :scale="[4,8]"
                        :value="zipcode"
                        @input="$emit('update:zipcode', $event)"
                    />
                </div>
                <div class="col-6">
                    <info-text-input
                        :label="resource('Address_HouseNo')"
                        :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_HouseNo')"
                        :isEnabled="isEnabled"
                        :scale="[7,5]"
                        :value="houseNo"
                        @input="$emit('update:houseNo', $event)"
                    />
                </div>
            </div>
            <info-text-input
                :label="resource('Address_City')"
                :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_City')"
                :isEnabled="isEnabled"
                :scale="[2,10]"
                :value="city"
                @input="$emit('update:city', $event)"
            />
            <info-text-input
                :label="resource('Address_Country')"
                :placeholder="resource('DmVisualizer_ChangeInfo_Placeholder_Country')"
                :isEnabled="isEnabled"
                :scale="[2,10]"
                :value="country"
                @input="$emit('update:country', $event)"
            />
        </info-item>
    </div>
</template>

<script>

//mixins
import resourceMixin from '../../../../Util/Mixins/resources';

//components
import InfoItem from './InfoItem.vue';
import InfoTextInput from './Components/InfoTextInput.vue';

export default {
    name: 'info-address',
    mixins: [resourceMixin],
    components: {
        InfoItem,
        InfoTextInput
    },
    data() {
        return {
            street: "",
            zipcode: "",
            houseNo: "",
            city: "",
            country: ""
        };
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
